<template>
  <Teleport to="body">
    <section
      v-if="visible"
      class="s-cgb-modal fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-7 xl:items-start xl:pt-24"
      :class="{ 'modal-container--purple': backgroundColor === 'purple', 'modal-container--white': backgroundColor === 'white' }"
      @click.self="emit('closeModal')"
    >
      <div
        :aria-label="name"
        role="dialog"
        aria-modal="true"
        class="modal-panel w-[95%] overflow-auto rounded-2xl bg-white shadow-lg sm:w-[90%] lg:w-[85%] xl:w-[75%] xl:max-w-[1024px]"
      >
        <div class="relative pt-5 px-5 pb-16 sm:pt-8 sm:px-8 md:pt-10 md:px-10 lg:p-20">
          <div class="cursor-pointer absolute flex items-start justify-end w-12 h-12 top-11 md:top-14 xl:top-[120px] close-modal" @click="emit('closeModal')">
            <AtomIconX class="w-5 h-5 sm:w-6 sm:h-6" />
          </div>
          <slot />
        </div>
      </div>
    </section>
  </Teleport>
</template>

<script setup lang="ts">
const props = defineProps({
  name: { type: String, required: true },
  visible: { type: Boolean, required: true },
  backgroundColor: { type: String, required: false, default: 'purple' },
})

const emit = defineEmits(['closeModal'])

// Matches vue-js-modal's default clickToClose/escToClose behavior.
function onKeydown(event: KeyboardEvent) {
  if (props.visible && event.key === 'Escape') {
    emit('closeModal')
  }
}

onMounted(() => document.addEventListener('keydown', onKeydown))
onUnmounted(() => document.removeEventListener('keydown', onKeydown))
</script>

<style scoped>
.modal-container--purple {
  background: rgba(95, 36, 159, 0.9);
}

.modal-container--white {
  background: rgba(242, 239, 236, 0.9);
}

.s-cgb-modal .modal-panel {
  overscroll-behavior: none;
  /* Matches vue-js-modal's own default max-height margin (its replaced library, see the comment above). */
  max-height: calc(100vh - 124px);
}

.s-cgb-modal .close-modal {
  right: 18px;
  top: 18px;

  @screen lg {
    right: 24px;
    top: 24px;
  }
}
</style>
